import { useSelector } from "react-redux";
import useCommon from "./useCommon";
import routes from "routes";
import { SYSTEM_ROLES } from "variables";

export default function usePermissions() {
  const { STORE } = useCommon();
  const { user: userInfo, loading } = STORE((state) => state.user);

  const permissions = userInfo?.role?.permissions || {};
  const level = userInfo?.role?.power || 0;
  const roleTitle = userInfo?.role?.title || "";

  const isSuperAdmin = roleTitle === SYSTEM_ROLES.SUPER_ADMIN.key;
  const isAdmin = roleTitle === SYSTEM_ROLES.ADMIN.key;
  const isHouseKeeper = roleTitle === SYSTEM_ROLES.HOUSEKEEPER.key;

  // const canView = (permission) => {
  //   return !!permissions[permission];
  // };

  const canView = (permission, route) => {
    if (route?.superAdminOnly === true && level !== 100) return false;

    return !!permissions[permission];
  };

  // Returns the first route the user can access
  const getFirstAllowedRoute = () => {
    for (const route of routes) {
      if (!route.route || !route.protected) continue;

      if (canView(route.permission)) {
        return route.route;
      }
    }

    return "/unauthorized";
  };

  const can = (permission) => {
    if (level === 100) return true; // superadmin override
    return !!permissions[permission];
  };

  return {
    can,
    canView,
    getFirstAllowedRoute,
    all: permissions,
    level,
    roleTitle,
    isSuperAdmin,
    isAdmin,
    isHouseKeeper,
  };
}
